"use client";

import React, { useState, useMemo } from "react";
import PropTypes from "prop-types";
import {
   MediaAgeVerificationFrame as AgeVerificationFrame,
} from 'common/components/modules/media';
import { MediaImageCard, MediaLockedCard } from 'common/designer-modules/modules/media/modules';
import ImgGallery from 'common/components/modules/img-gallery'
import Modal from 'common/components/modules/modalV2'
import PhotosetInsideModal from 'common/components/modules/chat/show-content/photoset'
import Button from 'common/components-v2/elements/button';

const PhotosetMediaContent = ({
   data,
   photos,
   isAgeVerificationRequired,
   addView = () => {},
   isMobile,
   openNSFWModal,
}) => {
   const [modal, setModal] = useState({ isOpen: false, index: null, photos: photos })

   const poster = isAgeVerificationRequired && Boolean(data.sfw_thumbnail)  ? data.sfw_thumbnail : data.cover_photo;
   const posterIsSfw =  isAgeVerificationRequired && !data.thumbnail_is_sfw;
   const [showImageGalleryButtons, setShowImageGalleryButtons] = useState(false)

   const photosetStartIndex = useMemo(() => {
      let result = 0
      let isFound = false;
      if(isAgeVerificationRequired && Array.isArray(photos) && Array.isArray(data.thumbnails)) {
         data.thumbnails.forEach(id => {
            // Check if result already assigned
            if(isFound) return;

            let firstSfwPhotoIndex = photos.findIndex(item => Boolean(item?.cf_path_photo) && item?.is_sfw && item?.id === id)
            if(firstSfwPhotoIndex >= 0) {
               result = firstSfwPhotoIndex
               isFound = true
            }

         })
      }

      return result;
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [data])

   if(data?.is_published && photos && photos?.length && poster){ // Image gallery
      const images = photos.filter(item => !!item?.cf_path_photo).map(item => {
         let originalClass = ''

         if(!item.is_sfw && isAgeVerificationRequired) {
            // originalClass = isDefaultThumbnailSFW ? '_default_thumbnail_is_sfw' : '_default_thumbnail_blured_for_sfw'
            originalClass = '_default_thumbnail_blured_for_sfw'
         }

         return {
            original: item.cf_path_photo,
            originalClass: originalClass,
            isShowAgeVerifyButton: !!originalClass,
         }
      })
      return (
         <div className='relative w-full'>

            <ImgGallery
               images={ images }
               classNameIconDiv='next-icon-classes mms-media-button-wrapper-bg'
               openModalInsteadOfFullScreen={ index => {
                  addView()
                  setModal({
                     isOpen: true,
                     index,
                     photos: data?.photos,
                  })
               } }
               disableKeyDown={ !!modal?.isOpen }
               onClickVerifyButton={ () => () => {} }
               showPlayButton={ showImageGalleryButtons && photos?.length > 1 }
               withZoomFuntion={ showImageGalleryButtons }
               showFullScreen={ showImageGalleryButtons }
               isPreventFullScreenAction={ isAgeVerificationRequired && !data.photoset_is_sfw && isMobile }
               startIndex={ photosetStartIndex }
               onChangeScreen={ bool => {
                  if(isAgeVerificationRequired && !data.photoset_is_sfw) {
                     if(openNSFWModal) {
                        openNSFWModal()
                     }
                     return;
                  }
                  setShowImageGalleryButtons(bool)
               } }
            />
            {
               modal?.isOpen && (
                  <Modal
                     contentPosition={ !isMobile ? 'center' : 'bottom' }
                     className='h-full overflow-hidden'
                     onClose={ () => setModal({ isOpen: false, index: null }) }
                     otherClassName={ 'w-full' }
                     closeOnClickOutside
                     contentWidth={ !isMobile ? '80vw' : '' }
                  >
                     <div
                        className='relative'
                        id='photoset-list-inside-modal'
                     >
                        <Button
                           size='small'
                           type='pill'
                           leftIconName='close'
                           onClick={ () => setModal({ isOpen: false, index: null }) }
                           className='absolute right-0 top-0 m-4 z-20'
                        />
                        <PhotosetInsideModal
                           data={ modal.photos }
                           galleryProps={ {
                              classNameIconDiv: 'next-icon-classes mms-media-button-wrapper-bg',
                              startIndex: modal?.index,
                              showPlayButton: modal?.photos?.length > 1,
                              disableKeyDown: false,
                              withZoomFuntion: true,
                              isInsideModal: true,
                              showBullets: false,
                              onClickFullScreen: index => {
                              },
                           } }
                           isAgeVerificationRequired={ isAgeVerificationRequired }
                        />
                     </div>
                  </Modal>
               )
            }
         </div>
      )
   }

   if(!poster){ // UNLOCKED STATE
      return (
         <MediaLockedCard blurhash={ data.blurhash } />
      )
   }

   return (
      <>
         <MediaImageCard
            poster={ poster }
            lockedForSFW={ posterIsSfw }
         />
         {
            posterIsSfw && (
               <AgeVerificationFrame
                  className='cover_image_wrapper_hover_element hidden z-10'
                  onClickVerifyAgeButton={ _ => {} }
               />
            )
         }
      </>
   )

}

PhotosetMediaContent.propTypes = {
   data: PropTypes.object,
   photos: PropTypes.array,
   isAgeVerificationRequired: PropTypes.bool,
   openNSFWModal: PropTypes.bool,
   isMobile: PropTypes.bool,
   addView: PropTypes.func,
};

export default PhotosetMediaContent;
